import { SET_PANEL } from './mutation-types';

const actions = {
    setPanels ({ dispatch }, panels){
        if(panels){
            for(let e=0, elen=panels.length; e<elen; e++){
                let panel = panels[e];
                if(panel.id){
                    dispatch('setPanel', panel);
                }
            }
        }
    },
    setPanel ({ commit }, {id, ...params}){
        commit(SET_PANEL, {id, ...params});
    },
    openPanel ({ commit }, id){
        commit(SET_PANEL, {id, show: true});
    },
    closePanel ({ commit }, id){
        commit(SET_PANEL, {id, show: false});
    },
    togglePanel ({ commit, getters }, id){
        commit(SET_PANEL, {id, show: !getters.getPanelStatus(id)});
    },
    closeAllPanels ({ commit, getters }){
        let panels = getters.getPanels;
        for(let e=0, elen=panels.length; e<elen; e++){
            let panel = panels[e];
            if(panel.id){
                if(panel.showDefault !== undefined && panel.showDefault){
                    continue;
                }
                commit(SET_PANEL, {id: panel.id, show: false});
            }
        }
    },
    setEstimateFeature ({ dispatch }, feature) {
        dispatch('setPanel', {id: 'estimate', feature});
    },
};

export default actions;
